import React from 'react';

import PlaceholderTab from '../../shared/PlaceholderTab';

import { EGS_FIELDS } from './fields';

export default function EgsTab() {
  return <PlaceholderTab configuredFieldCount={EGS_FIELDS.length} title="EGS" />;
}
